export default "__VITE_ASSET__DCo01362__"